module.exports = __webpack_public_path__ + "media/images/lb/453-4b378a7fc60c8c7393ace5d2ccaa70ea.svg";